import React, { useContext } from 'react';
import { EnvironmentCheckItemToRender } from '../CheckResults';
import translationKeys from 'translationKeys';
import TranslationsContext from 'translations/TranslationsContext';



interface ITitleColumnProps {
	item: EnvironmentCheckItemToRender;
}

const capitalizeFirstLetter = (text: string): string  => text.charAt(0).toUpperCase() + text.slice(1);

const TitleColumn = ({ item }: ITitleColumnProps) => {
	const { t } = useContext(TranslationsContext)!;

	let content: string = '';
	const style: React.CSSProperties | undefined = item.isChild ? { marginLeft: '1.75rem' } : undefined;

	if (item.titleKey) {
		const keyWithCapitalizedFirstLetter = capitalizeFirstLetter(item.titleKey);
		const translationKey = `EnvironmentCheckTitles.${keyWithCapitalizedFirstLetter}`;
		if (translationKeys.EnvironmentCheckTitles.hasOwnProperty(keyWithCapitalizedFirstLetter)) {
			content = t(translationKey);
		}
	}

	return <span style={style}>{content}</span>;
};

export default TitleColumn;
